<template lang="html">
  <div class="machine">
    <img :src="img" :alt="name + ' machine photo'" class="machine__img">
    <p class="machine__name">{{ name }}</p>
    <hr class="machine__divider" />
    <ul class="machine__list">
      <li v-for="advantage in advantages" :key="advantage" class="machine__item">
        {{ advantage }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    img: String,
    advantages: Array,
  }
}
</script>

<style lang="scss">
.machine {
  border: 3px solid black;
  width: 30rem;
  height: 44rem;
  border-radius: 5px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    height: auto;
    min-height: 44rem;
    width: 34rem;
  }

  &__img {
    display: block;
    width: 100%;
    height: 40%;
  }

  &__divider {
    width: 80%;
  }

  &__name {
    text-align: center;
    font-size: 2.2rem;
    margin: 1rem 0;
    font-weight: bold;
  }

  &__list {
    padding: 15px 45px;
  }

  &__item {
    font-size: 1.2rem;
    padding: 0.2rem;
  }
}
</style>